import { Attrs, MinzeElement } from 'minze'

export interface LvcCharlieIcon {
  width?: number
  height?: number
}

export class LvcCharlieIcon extends MinzeElement {
  attrs: Attrs = [
    ['width', 235],
    ['height', 235],
  ]
  html = () => `
    <img width="${this.width}" height="${this.height}" src='https://cloud.squidex.io/api/assets/lvc-dev/8b9115e4-aaf6-4439-9455-c0fe21bc29e7/pointeur.png?version=0&auto=true'/>
  `

  css = () => `
  `
}
